<template>
  <div style="background-color: #f4fbff; height: 100vh">
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="mypage mypage_change" v-show="isInfoBack">
      <div class="wrap mypage_wrap">
        <div class="mypage_input-box">
          <van-form style="width: 100%; max-width: 500px" ref="form">
            <p class="mypage_your-id">ＩＤ</p>
            <input
              v-model="userInfo.login_id"
              type="text"
              id="id"
              name="id"
              required
              minlength="4"
              maxlength="8"
              size="10"
            />

            <p class="mypage_your-name">名前</p>
            <div class="mypage_name-box">
              <input
                type="text"
                id="name"
                name="name"
                required
                size="10"
                v-model="userInfo.name"
              />
              <button class="btn_input-del">
                <img
                  src="../../assets/img/mypage/mypage_close.png"
                  alt="初期化"
                  @click="clearName"
                />
              </button>
            </div>
          </van-form>
        </div>
        <div style="margin-top:200px">
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            @click="handleSure"
            id="mypage_btn"
            :disabled="!this.userInfo.name"
            :color="!this.userInfo.name ? '#AACBE7' : '#3B82C4'"
          >
            変更する
          </van-button>
          <van-button
            round
            block
            type="primary"
            @click="signOut"
            id="mypage_btn"
            style="margin: 20px 0"
            :color="'#f80000'"
          >
            ログアウト
          </van-button>
          <div v-show="userInfo.login_id==='mbp001' || userInfo.login_id==='testd01'">
            <van-button
            round
            block
            type="primary"
            @click="showUuid"
            style="margin: 20px 0"
            :color="'#f80000'"
            >
              test uuid
            </van-button>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetUserDetails,
  UpdateUser,
  LoginedOut,
  Logout,
} from "@/services/user";
import { Toast } from "vant";
import "vant/es/toast/style";
import { Dialog } from "vant";
import "vant/es/dialog/style";
import Janus from "@/assets/js/janus";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {
      userInfo: {},
      isInfoBack: false,
    };
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.initUserInfo();
  },
  methods: {
    showUuid(){
      if (typeof device !== 'undefined' && device.uuid !== null && typeof device.uuid !== 'undefined') {
        alert(device.uuid);
      } else {
        alert('not havve uuid');
      }
    },
    signOut() {
      Dialog.confirm({
        title: "ログアウトしますか？",
      })
        .then(() => {
          LoginedOut({ token: localStorage.getItem("refreshtoken") }).then(
            () => {
              const code = localStorage.getItem(process.env.VUE_APP_CODE_KEY);
              Logout();
              if (Janus) {
                Janus.videoPageDestory();
              }
              this.$router.push({
                path: "/login",
                query: {
                  code: code,
                },
              });
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    handleSure() {
      const detail = this.userInfo;
      var updateData = {};
      updateData['id'] = detail.id;
      updateData['name'] = detail.name;
      this.$refs.form
        .validate()
        .then(() => {
          UpdateUser(updateData).then((res) => {
            if (res.data.code >= 0) {
              Toast.success("プロフィールが変更されました。");
            } else {
              Toast.fail("プロフィールが変更できませんでした");
            }
          });
        })
        .catch(() => {});
    },
    initUserInfo() {
      GetUserDetails().then((res) => {
        this.userInfo = res.data.data.detail;
        this.isInfoBack = true;
      });
    },
    onClickLeft() {
      history.back();
    },
    clearName() {
      this.userInfo.name = ''
    },
  },
};
</script>

<style scoped>
   
   
  
#name:focus {
  border: 2px solid #e59700;
}
</style>
